import { useEffect, useRef } from "react"
import { trackListingView } from "@lib/api/listing-popularity"

export function useListingView(id: number) {
    const ref = useRef({})
    useEffect(() => {
        if (!ref.current[id]) {
            trackListingView(id)
            ref.current[id] = true
        }
    }, [id])
}
